import TB from '@tiger/bridge';
import getDeviceId from '@tiger/device-id';
import { trackEvent, trackPageview } from '@tiger/track';
import COOKIE from 'cookick';
import { getWebOS, isOS, isTiger as isTigerFunc } from '@tiger/utils/userAgent';
import pkg from 'package.json';
import { TenantType } from 'types/common';
import { language } from 'utils/i18n';
import { getStorageOrUrlValue } from 'utils/storage';
import URL from 'utils/URL';
import { QueryAccountType } from './helper';

const pkgVersion = pkg.version.split('-')[0].replace(/[a-zA-Z]/g, '');
const ua = window.navigator.userAgent;

class APPStore {
    deviceId: string = getDeviceId();

    // 重置设备ID，适用于退出场景
    resetDeviceId() {
        localStorage.removeItem('TIGER_DEVICE_ID');
        COOKIE.delCookie('TIGER_DEVICE_ID');

        this.deviceId = getDeviceId();
    }

    isTiger = isTigerFunc();
    // 是否是tigertrade内访问，目前global account需求下，会在tigertrade中产生marsco账户.
    isTigerTrade = /tigertrade/i.test(ua);
    isWeiXin = /micromessenger/i.test(ua);
    isWeiBo = /weibo/i.test(ua);
    isQQ = /qq/i.test(ua);
    isAndroid = isOS('Android');
    isIOS = isOS('iOS');
    isMobile = this.isAndroid || this.isIOS;
    isDev = process.env.NODE_ENV === 'development';
    isEn = language.startsWith('en');

    //  多租户的tenant
    //  https://tigertech.feishu.cn/wiki/QVfGwpFUyizgwNk4OSBclyMsnKe#share-VV8bdx8oQoIj3oxCPfpciDbvnIe
    tenantId: TenantType = this.isTigerTrade ? 'TBGLOBAL' : 'TBUS';

    appVer = TB.getVersions()?.appVersion || pkgVersion;
    version = pkgVersion;
    shortVersion = pkg.version.split('-')[0].replace(/[a-zA-Z]/g, '');
    vendor = 'web';
    lang = language;
    platform: 'web' | 'h5' = this.isTiger ? 'h5' : 'web';
    // os: 'iOS', 'Android', 'Mac', 'Windows', 'HarmonyOS', 'Linux', 'Ubuntu', 'others'
    os = getWebOS();
    category = 'individual_us';
    queryAccount = getStorageOrUrlValue('account', 'session') as QueryAccountType;

    // 用于打开链接，非当前应用路由的
    updateHref(url: string, newPage?: boolean) {
        let resultUrl = url;
        const urlObj = URL.parse(resultUrl);

        if (!urlObj.host) {
            resultUrl = URL.merge(window.location.href, resultUrl);
        }

        if (newPage) {
            if (this.isTiger) {
                TB.openInNewPage(resultUrl);
            } else {
                window.open(resultUrl);
            }
        } else {
            window.location.href = resultUrl;
        }
    }

    /**
     * @desc
     * trackEvent(category, action, opt_label, opt_value); https://tongji.baidu.com/web/help/article?id=236&type=0
     *
     * @param category 事件分类，一般以业务模块作为区分，例如 deposit、withdraw
     * @param action 事件动作，大部分情况下应该都是 click
     * @param label 事件标签，这里可以根据具体收集的事件动作位置命名，例如 submit
     *          注意：因为百度统计后台无法组合category、action、label来筛选事件查看数据，所以为了方便统计，
     *          实际际发送给百度统计的label，是会在前面按照 category:action:label 的格式拼接，
     *          所以如果在不同模块页面添加事件追踪时指定了明确的cateogry、action，
     *          那么，不同页面即使有相同的label也是允许的
     * @param opt_value 事件价值，一般无需指定，默认为1，只允许整数值
     *
     * 例如，trackEvent('deposit', 'click', 'submit') 将会实际调用 _hmt.push(['_trackEvent', 'AMS:depoisit', 'click', 'AMS:deposit:click:submit'])
     *
     */
    trackEvent(category: string, action: string, label: string, opt_value?: number) {
        trackEvent(category, action, label, opt_value);
    }

    // trackPageview(pathname); https://tongji.baidu.com/web/help/article?id=235&type=0
    trackPageview(pathname: string) {
        if (!this.isDev) {
            const path = process.env.BASE_NAME + pathname;

            trackPageview(path);
        }
    }
}

const APP = new APPStore();

export default APP;

/**
 * 如果在app中，添加一个class
 */
if (APP.isTiger) {
    document.body.classList.add('within-app');
}
